import { render, staticRenderFns } from "./ProductGlassUnitsTable.vue?vue&type=template&id=8dbdff76&"
import script from "./ProductGlassUnitsTable.vue?vue&type=script&lang=js&"
export * from "./ProductGlassUnitsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductGlassUnitsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports